"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var icons_1 = require("./icons/icons");
var BosIcon_styled_1 = require("./BosIcon.styled");
/**
 * An Icon is a piece of visual element, but we must ensure its accessibility while using it.
 * An Icon can have two purposes:
 *
 * - *Decorative only*: For example, it illustrates a label next to it. We must ensure that it is ignored by screen readers, by setting `aria-hidden` attribute (ex: `<Icon icon="check" aria-hidden />`)
 * - *Non-decorative*: It means that it delivers information. For example, an icon as only child in a button. The meaning can be obvious visually, but it must have a proper text alternative via `aria-label` for screen readers. (Example: `<Icon icon="e-mail" aria-label="Send an e-mail" />`)
 */
exports.Icon = function (_a) {
    var icon = _a.icon, block = _a.block, filled = _a.filled, _b = _a.border, border = _b === void 0 ? false : _b, props = tslib_1.__rest(_a, ["icon", "block", "filled", "border"]);
    return (React.createElement(BosIcon_styled_1.Svg, tslib_1.__assign({ viewBox: icons_1.viewbox[icon], width: 32, height: 32, block: block, filled: filled, border: border }, props),
        React.createElement(BosIcon_styled_1.Path, { d: icons_1.icons[icon] })));
};
exports.Icon.defaultProps = {
    border: false,
    filled: false,
};
//# sourceMappingURL=BosIcon.js.map